export default {"src":"/_next/static/media/spirituele-sport.d686c4e5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};